/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './login.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../app/auth/login/login.component';
import * as i3 from './login-form/login-form.component.ngfactory';
import * as i4 from '../../../../app/auth/login/login-form/login-form.component';
import * as i5 from '@angular/forms';
import * as i6 from '@angular/router';
import * as i7 from '@angular/common';
import * as i8 from '@ngx-translate/core/src/translate.directive';
import * as i9 from '@ngx-translate/core/src/translate.service';
import * as i10 from '../../../../app/core/services/api/auth-http.service';
import * as i11 from '../../../../app/core/services/visual/toaster.service';
const styles_LoginComponent:any[] = [i0.styles];
export const RenderType_LoginComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_LoginComponent,data:{}});
export function View_LoginComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),21,'main',[['id',
      'page_login']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['\n  '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          18,'div',[['class','container']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n    '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),15,'div',[['class','content']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['\n      '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),0,'img',[['alt','Lantago'],['src','assets/img/h-logo-dark.svg']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['\n      '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),4,'div',[['class','form']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n        '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),1,'ltg-login-form',([] as any[]),
          (null as any),[[(null as any),'login']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i2.LoginComponent = _v.component;
            if (('login' === en)) {
              const pd_0:any = ((<any>_co.onLogin($event)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i3.View_LoginFormComponent_0,i3.RenderType_LoginFormComponent)),i1.ɵdid(114688,
          (null as any),0,i4.LoginFormComponent,[i5.FormBuilder],(null as any),{login:'login'}),
      (_l()(),i1.ɵted((null as any),['\n      '])),(_l()(),i1.ɵted((null as any),['\n      '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),4,'p',[['class','text-center']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),3,'a',[['routerLink','/recover-password'],
          ['translate','']],[[1,'target',0],[8,'href',4]],[[(null as any),'click']],
          (_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,16).onClick($event.button,$event.ctrlKey,
                  $event.metaKey,$event.shiftKey)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(671744,(null as any),0,i6.RouterLinkWithHref,
          [i6.Router,i6.ActivatedRoute,i7.LocationStrategy],{routerLink:[0,'routerLink']},
          (null as any)),i1.ɵdid(8536064,(null as any),0,i8.TranslateDirective,[i9.TranslateService,
          i1.ElementRef,i1.ChangeDetectorRef],{translate:[0,'translate']},(null as any)),
      (_l()(),i1.ɵted((null as any),['auth.login.recoverPassword'])),(_l()(),i1.ɵted((null as any),
          ['\n    '])),(_l()(),i1.ɵted((null as any),['\n  '])),(_l()(),i1.ɵted((null as any),
          ['\n'])),(_l()(),i1.ɵted((null as any),['\n']))],(_ck,_v) => {
    _ck(_v,11,0);
    const currVal_2:any = '/recover-password';
    _ck(_v,16,0,currVal_2);
    const currVal_3:any = '';
    _ck(_v,17,0,currVal_3);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,16).target;
    const currVal_1:any = i1.ɵnov(_v,16).href;
    _ck(_v,15,0,currVal_0,currVal_1);
  });
}
export function View_LoginComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'ltg-login',([] as any[]),
      (null as any),(null as any),(null as any),View_LoginComponent_0,RenderType_LoginComponent)),
      i1.ɵdid(49152,(null as any),0,i2.LoginComponent,[i10.AuthHttpService,i6.Router,
          i11.ToasterService],(null as any),(null as any))],(null as any),(null as any));
}
export const LoginComponentNgFactory:i1.ComponentFactory<i2.LoginComponent> = i1.ɵccf('ltg-login',
    i2.LoginComponent,View_LoginComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci93d3cvbGFudGFnby1hcHAvbGFudGFnby1hcHAtZGVtby9zcmMvYXBwL2F1dGgvbG9naW4vbG9naW4uY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3Zhci93d3cvbGFudGFnby1hcHAvbGFudGFnby1hcHAtZGVtby9zcmMvYXBwL2F1dGgvbG9naW4vbG9naW4uY29tcG9uZW50LnRzIiwibmc6Ly8vdmFyL3d3dy9sYW50YWdvLWFwcC9sYW50YWdvLWFwcC1kZW1vL3NyYy9hcHAvYXV0aC9sb2dpbi9sb2dpbi5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3Zhci93d3cvbGFudGFnby1hcHAvbGFudGFnby1hcHAtZGVtby9zcmMvYXBwL2F1dGgvbG9naW4vbG9naW4uY29tcG9uZW50LnRzLkxvZ2luQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPG1haW4gaWQ9XCJwYWdlX2xvZ2luXCI+XG4gIDxkaXYgY2xhc3M9XCJjb250YWluZXJcIj5cbiAgICA8ZGl2IGNsYXNzPVwiY29udGVudFwiPlxuICAgICAgPGltZyBzcmM9XCJhc3NldHMvaW1nL2gtbG9nby1kYXJrLnN2Z1wiIGFsdD1cIkxhbnRhZ29cIj5cbiAgICAgIDxkaXYgY2xhc3M9XCJmb3JtXCI+XG4gICAgICAgIDxsdGctbG9naW4tZm9ybSAobG9naW4pPVwib25Mb2dpbigkZXZlbnQpXCI+PC9sdGctbG9naW4tZm9ybT5cbiAgICAgIDwvZGl2PlxuICAgICAgPHAgY2xhc3M9XCJ0ZXh0LWNlbnRlclwiPjxhIHJvdXRlckxpbms9XCIvcmVjb3Zlci1wYXNzd29yZFwiIHRyYW5zbGF0ZT5hdXRoLmxvZ2luLnJlY292ZXJQYXNzd29yZDwvYT48L3A+XG4gICAgPC9kaXY+XG4gIDwvZGl2PlxuPC9tYWluPlxuIiwiPGx0Zy1sb2dpbj48L2x0Zy1sb2dpbj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTtNQUFzQix5Q0FDcEI7VUFBQTtVQUFBLDhCQUF1QjtNQUNyQjtVQUFBO01BQXFCLDZDQUNuQjtVQUFBO1VBQUE7TUFBb0QsNkNBQ3BEO1VBQUE7VUFBQSw4QkFBa0I7TUFDaEI7VUFBQTtZQUFBO1lBQUE7WUFBZ0I7Y0FBQTtjQUFBO1lBQUE7WUFBaEI7VUFBQSx5RUFBQTtVQUFBO01BQTJELDZDQUN2RDtNQUNOO1VBQUE7TUFBdUI7VUFBQTtVQUFBO1lBQUE7WUFBQTtjQUFBO2tCQUFBO2NBQUE7WUFBQTtZQUFBO1VBQUEsdUNBQUE7VUFBQTtVQUFBLHNCQUFBOzRDQUFBO01BQTRDLCtEQUFrQztVQUFBLGFBQ2pHLHlDQUNGO1VBQUEsU0FDRDtJQUxDO0lBRXdCO0lBQUgsWUFBRyxTQUFIO0lBQWtDO0lBQWxDLFlBQWtDLFNBQWxDOztJQUFBO0lBQUE7SUFBQSxZQUFBLG1CQUFBOzs7O29CQ1A3QjtNQUFBO2FBQUE7NEJBQUE7OzsifQ==



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/$$_gendir/app/auth/login/login.component.ngfactory.ts